import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { createAmerikolayApp } from "./App";
import AuthOverlay from "./AuthOverlay";
import JobsOverlay from "./JobsOverlay";
import "./index.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Amerikolay uygulama kökü bulunamadı.");
}

const application = (
  <StrictMode>
    {createAmerikolayApp(window.location.pathname)}
  </StrictMode>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, application);
} else {
  createRoot(root).render(application);
}

let authRoot = document.getElementById("auth-root");
if (!authRoot) {
  authRoot = document.createElement("div");
  authRoot.id = "auth-root";
  document.body.appendChild(authRoot);
}
createRoot(authRoot).render(<AuthOverlay />);

let jobsRoot = document.getElementById("jobs-root");
if (!jobsRoot) {
  jobsRoot = document.createElement("div");
  jobsRoot.id = "jobs-root";
  document.body.appendChild(jobsRoot);
}
createRoot(jobsRoot).render(<JobsOverlay />);
